/**
 *
 * Profile Menu
 *
 */
import React, { useContext } from 'react';

import { Avatar, Box, MenuItem, useDisclosure, Center } from '@chakra-ui/react';
import { FaSignOutAlt, IoMdPerson } from 'react-icons/all';
import { useNavigate } from 'react-router-dom';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import {
  EventLogIcon,
  InformationIcon,
  QuestionCircleIcon,
  RefreshIcon,
} from 'components/Icons';
import { AriksaFAQ } from 'components/Navigation/NavBar/TopNavBar/RightComponent/FAQ';
import { MyTasks } from 'components/Navigation/NavBar/TopNavBar/RightComponent/MyTasks';

import { defaultMenuStyles, Menu } from '../../../../Overlay/Menu';
import { NavBarContext } from '../../context';
import { profileMenuStyles } from '../styles';

interface Props {}

export const ProfileMenu: React.FC<Props> = props => {
  const { onLogout, resetPassword, showWelcomeScreen, user } = useContext(
    NavBarContext,
  );
  const tasks = useDisclosure();
  const faq = useDisclosure();
  const isMasterOrg = user.info?.org_id === 'master';
  const navigate = useNavigate();

  const menu = [
    ...(!showWelcomeScreen
      ? [
          {
            title: 'Help',
            //url: '',
            icon: QuestionCircleIcon,
            onClick: () => {
              faq.onOpen();
            },
          },
          {
            title: 'Explore',
            //url: '',
            icon: InformationIcon,
            onClick: () => {
              tasks.onOpen();
            },
          },
        ]
      : []),
    ...(!showWelcomeScreen && !isMasterOrg
      ? [
          {
            title: 'Ariksa Event Logs',
            url: '/event-log',
            icon: EventLogIcon,
          },
        ]
      : []),
    { title: 'Your Profile', url: '/user-profile', icon: IoMdPerson },
    {
      title: 'Reset Password',
      onClick: resetPassword,
      icon: RefreshIcon,
      url: '',
    },
    { title: 'Sign Out', onClick: onLogout, icon: FaSignOutAlt },
  ];

  return (
    <Box {...profileMenuStyles.root}>
      <Menu
        buttonLabel={
          <CustomTooltip
            label={
              user.info?.first_name
                ? user.info?.first_name + ' ' + user.info?.last_name
                : user.info.username
            }
            placement={'bottom'}
          >
            <Box pos="relative">
              <Avatar
                size="sm"
                name={
                  user.info?.first_name
                    ? user.info?.first_name + ' ' + user.info?.last_name
                    : user.info.username
                }
                color="primary"
                fontWeight={600}
                bg="white"
                p={0.5}
                //src={user.info?.avatar}
                //src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              />
            </Box>
          </CustomTooltip>
        }
        itemsComponent={menu.map(each => (
          <Box key={`${each.title.split(' ').join('-')}-profile-menu`} px={2}>
            <MenuItem
              {...defaultMenuStyles?.item}
              onClick={e =>
                each?.url ? navigate(each.url) : each.onClick && each.onClick(e)
              }
            >
              <Box mr={2} boxSize={5}>
                <Center w="full" h="full">
                  <each.icon />
                </Center>
              </Box>
              {each.title}
            </MenuItem>
          </Box>
        ))}
        styles={{
          button: { ...profileMenuStyles.menuButton, mr: 0 },
        }}
      />
      {tasks.isOpen && (
        <MyTasks isOpen={tasks.isOpen} onClose={tasks.onClose} />
      )}
      {faq.isOpen && (
        <AriksaFAQ
          isOpen={faq.isOpen}
          onClose={faq.onClose}
          onOpen={faq.onOpen}
        />
      )}
    </Box>
  );
};

export default ProfileMenu;
